import styled from "styled-components"

export default styled.div`
  font-size: 18px; 
  font-weight: 600; 
  text-align: left; 
  margin: 32px auto 0px auto; 
  padding: 4px 4px 12px 4px; 
  color: #273561; 
`